var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{'is-active' : this.active}},[_c('div',{staticClass:"modal-background",on:{"click":function($event){return _vm.$emit('close')}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }